// src/store/modules/settings.js

const state = {
  requisites: '',
  supportEmail: '',
  copyright: ''
};

const mutations = {
  setSettings(state, payload) {
    state.requisites = payload.requisites;
    state.supportEmail = payload.support_email;
    state.copyright = payload.copyright;
  }
};

const actions = {
  async fetchSettings({ commit }) {
    // Replace with your actual API call
    const res = await this._vm.$http.get(process.env.VUE_APP_API + 'settings');
    if (res.data && res.data.payload) {
      commit('setSettings', res.data.payload);
    }
  }
};

const getters = {
  requisites: state => state.requisites,
  supportEmail: state => state.supportEmail,
  copyright: state => state.copyright
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
